__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "marketplace-mf-container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@belezanaweb/mktp-components", "1.0.0", () => (Promise.all([__webpack_require__.e(830), __webpack_require__.e(933), __webpack_require__.e(297), __webpack_require__.e(857), __webpack_require__.e(454), __webpack_require__.e(696)]).then(() => (() => (__webpack_require__(46933))))));
			register("@tanstack/react-query", "5.85.5", () => (Promise.all([__webpack_require__.e(149), __webpack_require__.e(297), __webpack_require__.e(782)]).then(() => (() => (__webpack_require__(45149))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(223), __webpack_require__.e(297)]).then(() => (() => (__webpack_require__(82223))))));
			register("react-hook-form", "7.55.0", () => (Promise.all([__webpack_require__.e(203), __webpack_require__.e(297)]).then(() => (() => (__webpack_require__(46203))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(35), __webpack_require__.e(297), __webpack_require__.e(857)]).then(() => (() => (__webpack_require__(25035))))));
			register("react", "18.3.1", () => (__webpack_require__.e(326).then(() => (() => (__webpack_require__(52326))))));
			initExternal(8463);
			initExternal(29713);
			initExternal(87661);
			initExternal(79045);
			initExternal(37289);
			initExternal(66937);
			initExternal(88640);
			initExternal(41545);
			initExternal(51097);
			initExternal(84166);
			initExternal(71849);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};